import React from "react";

import { Icon } from "@iconify/react/dist/iconify.js";

interface DocumentGridBreadcrumbProps {
  breadcrumbs: { id: string; name: string }[];
  clickOnPathCallback: (_path: { id: string; name: string }[]) => void;
  disabled?: boolean;
  rootText?: string;
}
const DocumentGridBreadcrumb: React.FC<DocumentGridBreadcrumbProps> = ({
  breadcrumbs,
  clickOnPathCallback,
  disabled,
  rootText = "Project files",
}) => {
  const getLinkDesign = (index: number) => {
    const baseClassName = "btn-default btn-default-style ";
    if (disabled) {
      return baseClassName + "cursor-default";
    }
    if (index + 1 == breadcrumbs.length) {
      return baseClassName + "weight-600 cursor-default";
    }
    return baseClassName + "cursor-pointer font-color-primary";
  };
  return (
    <div className="flex gap-8 align-items-center grid-header">
      <button
        onClick={() => {
          if (!disabled) {
            clickOnPathCallback(breadcrumbs.slice(0, -1));
          }
        }}
        disabled={breadcrumbs.length === 0}
        className={getLinkDesign(-1)}
        data-testid={`path-icon-previous`}
        style={{ marginTop: "7px" }}
      >
        <Icon icon="ei:arrow-up" width={20} height={20} color={"black"} />
      </button>
      <button
        onClick={() => {
          if (!disabled) {
            clickOnPathCallback([]);
          }
        }}
        className={getLinkDesign(-1)}
        data-testid="path-root"
      >
        {rootText}
      </button>
      {breadcrumbs.map((path, index) => (
        <div
          className="flex gap-8 align-items-center"
          key={`div-${path.id ?? index}`}
          data-testid={`div-${path.id ?? index}`}
        >
          <Icon
            icon="ic:baseline-chevron-right"
            width={20}
            height={20}
            color="#909294"
            key={`icon-${path.id ?? index}`}
          />
          <button
            key={`path-${path.id ?? index}`}
            onClick={() => {
              if (!disabled) {
                clickOnPathCallback(breadcrumbs.slice(0, index + 1));
              }
            }}
            className={getLinkDesign(index)}
            data-testid={`path-${path.id ?? index}`}
          >
            {path.name}
          </button>
        </div>
      ))}
    </div>
  );
};

export default DocumentGridBreadcrumb;
